export default __webpack_public_path__ + "static/media/PeristalticPumpsImg.51989937.jpg";